module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/2_4087b3c18ddb87f0f763bb231e0488f7.jpg";